import {QUERY_KEYS, queryClient} from '@/queryClient'

interface UseProjectMutationSuccessOptions {
    /**
     * Project ID to invalidate queries for
     */
    projectId: string
    /**
     * Optional callback to run after the queries are invalidated
     */
    onComplete?: () => void
}

/**
 * Hook to handle standard project mutation success flow:
 * - Cancel pending project queries
 * - Invalidate project queries for specific ID
 * - Call optional completion callback
 */
export const useProjectMutationSuccess = ({projectId, onComplete}: UseProjectMutationSuccessOptions) => {
    return async () => {
        await queryClient.cancelQueries({queryKey: [QUERY_KEYS.PROJECT]})
        await queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT, projectId]})
        onComplete?.()
    }
}
